var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Eye = function Eye(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.132 11.504C3.907 6.647 7.52 4 12 4s8.093 2.647 10.868 7.504a1 1 0 0 1 0 .992C20.093 17.353 16.48 20 12 20s-8.093-2.647-10.868-7.504a1 1 0 0 1 0-.992ZM9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Eye;